import React, { useState } from 'react';
import PropTypes from 'prop-types';

interface TableRowProps {
  tableHeader: Object;
  row: any;
  onClick: Function;
}

function TableRow({ tableHeader, row, onClick }: TableRowProps) {
  const [isHoveredOn, setIsHoveredOn] = useState(false);

  const handleMouseEvents = (isInside: boolean) => {
    setIsHoveredOn(isInside);
  };

  return (
    <tr onClick={() => onClick(row)}>
      {Object.keys(tableHeader).map((key) => (
        <td
          key={key}
          onMouseEnter={() => handleMouseEvents(true)}
          onMouseLeave={() => handleMouseEvents(false)}
        >
          {row[key].componentRenderer
            ? row[key].componentRenderer({ isHoveredOn })
            : row[key].label}
        </td>
      ))}
    </tr>
  );
}

TableRow.propTypes = {
  tableHeader: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TableRow;
